/* ==========================================================
   Indian Vastraa — Protected Cart & Wishlist Badge Script
   ========================================================== */

(function () {
  'use strict';

  function getWishlistItems() {
    try {
      const stored = localStorage.getItem('shopify_wishlist_items') || localStorage.getItem('theme_wishlist_items') || '[]';
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function getWishlistHandles() {
    try {
      const stored = localStorage.getItem('shopify_wishlist') || localStorage.getItem('theme_wishlist') || localStorage.getItem('wishlist') || '[]';
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlistData(items, handles) {
    const itemsJson = JSON.stringify(items);
    const handlesJson = JSON.stringify(handles);

    localStorage.setItem('shopify_wishlist_items', itemsJson);
    localStorage.setItem('theme_wishlist_items', itemsJson);

    localStorage.setItem('shopify_wishlist', handlesJson);
    localStorage.setItem('theme_wishlist', handlesJson);
    localStorage.setItem('wishlist', handlesJson);
  }

  // 🛡️ GUARANTEED WISHLIST BADGE PROTECTION GUARD 🛡️
  function protectWishlistHeaderBadge() {
    const handles = getWishlistHandles();
    const realWishlistCount = handles.length;

    // Find any Heart Badge in header and lock it to the REAL Wishlist count!
    document.querySelectorAll('a[href*="wishlist"] .cart-count, a[href*="wishlist"] [class*="count"], .wishlist-link .cart-count, .wishlist-icon .cart-count, #wishlist-icon-bubble .cart-count').forEach(badge => {
      badge.classList.remove('cart-count'); // Strip conflicting cart class
      badge.classList.add('wishlist-count-protected');
      badge.textContent = realWishlistCount;
    });

    // Also update any dedicated wishlist count elements
    document.querySelectorAll('.wishlist-count, [data-wishlist-count]').forEach(badge => {
      badge.textContent = realWishlistCount;
    });
  }

  function updateHeaderCartBadges(cart) {
    if (!cart) return;
    const count = cart.item_count !== undefined ? cart.item_count : cart;

    // Target cart links ONLY
    document.querySelectorAll('a[href*="/cart"] .cart-count, a[href*="/cart"] .cart-count-bubble, a[href*="/cart"] [data-cart-count], .cart-icon-bubble .cart-count-bubble, #cart-icon-bubble .cart-count-bubble').forEach(badge => {
      badge.textContent = count;
      badge.classList.remove('hidden', 'is-hidden');
    });

    // Immediately protect Wishlist badge from theme script overwrites
    protectWishlistHeaderBadge();
    setTimeout(protectWishlistHeaderBadge, 50);
    setTimeout(protectWishlistHeaderBadge, 250);
    setTimeout(protectWishlistHeaderBadge, 600);
  }

  function initCollectionGrid() {
    // 1. INITIALIZE & PROTECT WISHLIST BADGES ON LOAD
    protectWishlistHeaderBadge();

    const handles = getWishlistHandles();
    document.querySelectorAll('.wishlist-toggle-btn').forEach(function (btn) {
      const handle = btn.getAttribute('data-handle');
      if (handle && handles.includes(handle)) {
        btn.classList.add('is-active');
      }
    });

    // 2. ⚡ INSTANT AJAX ADD TO CART ⚡
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('.quick-add-form');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      const btn = form.querySelector('.btn-quick-add-main');
      const originalHTML = btn ? btn.innerHTML : '<span>+ QUICK ADD</span>';

      if (btn) {
        btn.disabled = true;
        btn.innerHTML = `
          <svg class="btn-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.25"></circle>
            <path d="M12 2a10 10 0 0 1 10 10"></path>
          </svg>
          <span>ADDING...</span>
        `;
      }

      const formData = new FormData(form);
      const addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(item => {
        if (btn) {
          btn.style.background = '#2E7D32';
          btn.style.color = '#FFFFFF';
          btn.innerHTML = '<span>✓</span> <span>ADDED TO BAG!</span>';

          setTimeout(() => {
            btn.style.background = '';
            btn.style.color = '';
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 1800);
        }

        // Fetch updated cart JSON & update ONLY Cart Badges
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            updateHeaderCartBadges(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, item: item } }));
            
            if (window.theme && window.theme.cart && window.theme.cart.open) {
              window.theme.cart.open();
            }
          })
          .catch(() => {});
      })
      .catch(err => {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }
        form.submit();
      });
    });

    // 3. ❤️ WISHLIST TOGGLE ❤️
    document.addEventListener('click', function (e) {
      const wishlistBtn = e.target.closest('.wishlist-toggle-btn');
      if (wishlistBtn) {
        e.preventDefault();
        e.stopPropagation();

        const handle = wishlistBtn.getAttribute('data-handle');
        const id = wishlistBtn.getAttribute('data-product-id');
        const title = wishlistBtn.getAttribute('data-title');
        const price = wishlistBtn.getAttribute('data-price');
        const compare = wishlistBtn.getAttribute('data-compare');
        const image = wishlistBtn.getAttribute('data-image');
        const url = wishlistBtn.getAttribute('data-url');
        const variantId = wishlistBtn.getAttribute('data-variant-id');

        let items = getWishlistItems();
        let handles = getWishlistHandles();
        let isAdded = false;

        const existingIdx = items.findIndex(item => item.handle === handle || item.id === id);

        if (existingIdx > -1) {
          items.splice(existingIdx, 1);
          const hIdx = handles.indexOf(handle);
          if (hIdx > -1) handles.splice(hIdx, 1);
          isAdded = false;
        } else {
          items.push({
            handle: handle,
            id: id,
            title: title || 'Product',
            price: price || '',
            compare_at_price: compare || '',
            image: image || '',
            url: url || '/products/' + handle,
            variant_id: variantId || id
          });
          if (handle && !handles.includes(handle)) handles.push(handle);
          isAdded = true;
        }

        saveWishlistData(items, handles);

        document.querySelectorAll(`.wishlist-toggle-btn[data-handle="${handle}"]`).forEach(b => {
          if (isAdded) b.classList.add('is-active');
          else b.classList.remove('is-active');
        });

        protectWishlistHeaderBadge();

        if (window.SwymCallbacks && window._swat && id) {
          if (isAdded) {
            window._swat.addToWishList({ empid: id, epiid: variantId || id, du: window.location.href });
          }
        }

        document.dispatchEvent(new CustomEvent('wishlist:updated', { 
          detail: { handle: handle, id: id, active: isAdded, items: items, wishlist: handles } 
        }));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionGrid);
  document.addEventListener('shopify:section:load', initCollectionGrid);
})();